import R from 'ramda';
import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { fetchOrganizationByAlias } from 'common/authAjax';

import { fetchProject } from 'common/stipAjax';

import {
  isValidRoute,
  parseProjectKey,
  parseOrganizationAlias,
} from 'common/urlHelpers';

import { APP_STARTED, appError, appDataLoaded } from './applicationActions';

const DEFAULT_PROJECT_KEY = process.env.REACT_APP_DEFAULT_PROJECT_KEY;
const DEFAULT_ORGANIZATION_ALIAS =
  process.env.REACT_APP_DEFAULT_ORGANIZATION_ALIAS;

const getProjectKeyFromUrl = () =>
  parseProjectKey(window.location.href) || DEFAULT_PROJECT_KEY;
const getOrganizationAliasFromUrl = () =>
  parseOrganizationAlias(window.location.href) || DEFAULT_ORGANIZATION_ALIAS;

const checkRoute = () => {
  const { href } = window.location;

  return isValidRoute(href)
    ? Observable.of(href)
    : Observable.throw(new Error('Invalid url'));
};

const fetchAppData = () =>
  Observable.forkJoin([
    fetchProject(getProjectKeyFromUrl()),
    fetchOrganizationByAlias(getOrganizationAliasFromUrl()),
  ]).map(([project, organization]) => ({
    project,
    organization,
  }));

const appStartEpic = action$ =>
  action$
    .ofType(APP_STARTED)
    .mergeMap(() =>
      checkRoute()
        .mergeMap(fetchAppData)
        .map(appDataLoaded)
        .catch(R.pipe(appError, Observable.of)),
    );

export default combineEpics(appStartEpic);



// WEBPACK FOOTER //
// ./src/application/applicationEpic.js